import {useState,useEffect} from 'react';

import Event from '../../components/Event';
import ContentfulUtil from "../../util/ContentfulUtil";
import PageTitle from '../../components/PageTitle';
import PageContent from '../../components/PageContent';
 
function JrPlayers() {
  
  const [jrSeason, setJrSeason] = useState([]);

  useEffect(()=>{
    const fetchData = async () => {
        const currentSeason = await ContentfulUtil.getCurrentSeason();
        const filteredSeason = currentSeason.filter(show => show.fields.productionGroup == "Spotlight Jr. Players")
        setJrSeason(filteredSeason)
    };
  
    fetchData();
  },[])

  return (<>
    <PageTitle>
      Jr. Players
    </PageTitle>
    <PageContent>
      <div className="row">
        <div className="col-12">
          <img className="img-fluid w-100 mb-4" src="images/MoanaRehearsalBanner.png" alt="about image" />
          <h4>Spotlight Jr. Players</h4>
          <p>Spotlight Players is <strong>THRILLED</strong> to have the <strong>Spotlight Jr. Players</strong> as part of our group.  The goal of Spotlight Jr. Players is to give all those ages 18 and under a chance to shine on stage. All participants are required to become members of Spotlight Players. For more information about Membership, see our <a href='https://spotlightplayersmi.org/#/become-a-member'>Membership page</a>.</p>
           </div>
      </div>
      <div className="row bg-gray">
        <h4 className="col-12" style={{paddingTop:"15px"}}>Jr. Players Current Season Productions</h4>
        <div className="row justify-content-center" style={{width:"100%"}}>
          {jrSeason.map((event)=>{
              return <Event 
                key={event.sys.id}
                title={event.fields.name} 
                location={event.fields.location}  
                firstDay={event.firstPerformanceDate}
                imgSrc={event.fields.squareImage.fields.file.url} 
                production={event.fields.productionGroup} 
                link={event.getLink()} 
                dates={event.performances}>
              </Event>
          })}
        </div>
      </div>
    </PageContent>
  </>);
}

export default JrPlayers